<template>
    <v-container fluid class="px-8 px-md-6">

        <div class="properties-title">
            <h1>Properties</h1>
            <v-spacer></v-spacer>
            <map-list-tab
                class="d-flex d-md-none"
                v-on:tabClicked="display = $event"
                :map-tab="1"
            />
        </div>

        <v-tabs
            class="properties-tabs"
            slider-size="3"
            :grow="$vuetify.breakpoint.smAndDown"
            :centered="$vuetify.breakpoint.smAndDown"
            height="48"
            @change="tabChanged()"
        >
            <v-tab>Matches</v-tab>
            <v-tab v-if="isUserLoggedIn">Favorites</v-tab>
            <v-tab v-if="isUserLoggedIn">Contacted</v-tab>

            <v-tab-item>
                <v-row>
                    <v-col>
                        <PropertyFilters
                            v-on:tabClicked="display = $event"
                            :map-tab="1"
                        />
                    </v-col>
                </v-row>
                <PropertiesView
                    :display="display"
                    current-page-setter="setCurrentPage"
                />
            </v-tab-item>

            <v-tab-item class="properties-tabs-fav">
                <v-row class="justify-start mt-3">
                    <v-col cols="12" sm="6" md="4">
                        <v-select
                            :items="userRoommates"
                            item-text="name"
                            item-value="id"
                            outlined
                            dense
                            solo
                            flat
                            class="btn-edu-select-height"
                            v-model="contactedFilterOption"
                            @change="updateFavoriteProperties()"
                        >
                            <template slot="append">
                                <span>
                                    <v-icon size="18">mdi-chevron-down</v-icon>
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <div v-if="favoriteProperties && favoriteProperties.length > 0">
                    <v-row class="justify-start">
                        <v-col cols="12" md="6" lg="4" xl="3" v-for="property in favoriteProperties" :key="property.id">
                            <property-card :property="property" source="properties"></property-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col class="d-flex py-10 justify-center">
                            <Paginate
                                state="Properties"
                                collection="favoriteProperties"
                                list="getFavoriteProperties"
                            />
                        </v-col>
                    </v-row>
                </div>
                <div v-else class="pt-4">
                    <p><i>{{ emptyMessage.favorite }}</i></p>
                </div>

            </v-tab-item>

            <v-tab-item>
                <v-row class="justify-start mt-3">
                    <v-col cols="12" sm="6" md="4">
                        <v-select
                            :items="userRoommates"
                            item-text="name"
                            item-value="id"
                            outlined
                            dense
                            solo
                            flat
                            class="btn-edu-select-height"
                            v-model="contactedFilterOption"
                            @change="updateContactedProperties()"
                        >
                            <template slot="append">
                                <span>
                                    <v-icon size="18">mdi-chevron-down</v-icon>
                                </span>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>

                <div v-if="contactedProperties && contactedProperties.length > 0">
                    <v-row class="justify-start mt-3">
                        <v-col
                            cols="12"
                            md="6"
                            lg="4"
                            xl="3"
                            v-for="property in contactedProperties" :key="property.id"
                        >
                            <property-card
                                :property="property"
                                source="properties"
                            ></property-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col class="d-flex py-10 justify-center">
                            <Paginate
                                state="Properties"
                                collection="contactedProperties"
                                list="getContactedProperties"
                            />
                        </v-col>
                    </v-row>
                </div>
                <div v-else class="pt-4">
                    <p><i>{{ emptyMessage.contacted }}</i></p>
                </div>

            </v-tab-item>

        </v-tabs>

        <div class="d-flex justify-center">
            <div class="col-md-6 mb-4">
                <FaqCollapsible :page="page"/>
            </div>
        </div>

    </v-container>
</template>

<script>
import PropertyCard from "../components/PropertyCard";
import Paginate from "../components/Paginate";
import PropertyFilters from "../components/PropertyFilters";
import MapListTab from "../components/MapListTab";
import PropertiesView from "@/views/PropertiesView";
import FaqCollapsible from "@/components/FaqCollapsible";
import SiteService from "@/services/site.service";

export default {
    name: 'Properties',
    components: {
        FaqCollapsible,
        PropertiesView,
        Paginate,
        PropertyCard,
        PropertyFilters,
        MapListTab
    },
    data: () => ({
        propertiesList: 0,
        propertiesRoommates: 0,
        display: 'map',
        page: null,
        additionalOptions: [
            {
                name: "Me",
                id: "me"
            },
            {
                name: "Me and my roomies (Common Properties)",
                id: "meAndRoomies"
            }
        ],
        contactedFilterOption: "me",
        emptyMessage: {
            favorite: "You do not have any favorite properties yet.",
            contacted: "You do not have any contacted properties yet."
        }
    }),
    watch: {
        user(user) {
            if (user) {
                this.init()
            }
        }
    },
    computed: {
        isUserLoggedIn() {
            return this.$store.getters.isUserLoggedIn
        },
        user() {
            return this.$store.getters.getUser;
        },
        favoriteProperties() {
            return this.$store.getters.getFavoriteProperties;
        },
        contactedProperties() {
            return this.$store.getters.getContactedProperties;
        },
        roommates() {
            const roommates = this.$store.getters.getRoommates || [];

            return roommates.filter(
                roommate => !this.userRoommateIds.includes(roommate.id)
            )
        },
        userRoommates() {
            const roommates = this.$store.getters.getUserRoommates || [];
            const allOptions = this.additionalOptions.concat(roommates);

            return allOptions;
        },
        userRoommateIds() {
            const roommates = this.$store.getters.getUserRoommates || [];

            return roommates.map(roommate => roommate.id);
        },
    },
    methods: {
        tabChanged() {
            this.updateFavoriteProperties();
            this.updateContactedProperties();
        },
        init() {
            if (!this.user || !this.user.id) return;

            this.$store.commit('setCampusId', null);
            this.$store.commit('setStateId', null);
            this.$store.commit('setSearchCity', null);
            this.$store.commit('setCounty', null);

            this.$store.dispatch('getProperties');
            this.$store.dispatch('getFavoriteProperties', {roommateFilter: "me"});
            this.$store.dispatch('getContactedProperties', {roommateFilter: "me"});
            this.$store.dispatch('getSchools');
            this.$store.dispatch('getRoommates')
            this.$store.dispatch('getUserRoommates');
        },
        updateFavoriteProperties() {
            this.$store.dispatch('getFavoriteProperties', {
                roommateFilter: this.contactedFilterOption
            });

            switch (this.contactedFilterOption) {
                case "meAndRoomies":
                    this.emptyMessage.favorite = "You do not have any common favorite properties yet."
                    break;
                default:
                    this.emptyMessage.favorite = "You have not favorited any properties yet."
                    break;
            }
        },
        updateContactedProperties() {
            this.$store.dispatch('getContactedProperties', {
                roommateFilter: this.contactedFilterOption
            });

            switch (this.contactedFilterOption) {
                case "meAndRoomies":
                    this.emptyMessage.contacted = "You do not have any common contacted properties yet."
                    break;
                default:
                    this.emptyMessage.contacted = "You do not have any contacted properties yet."
                    break;
            }
        }
    },
    async beforeMount() {
        // Clear search state immediately before await, so child components
        // don't mount with stale search criteria from a previous page
        this.$store.commit('setCampusId', null);
        this.$store.commit('setStateId', null);
        this.$store.commit('setSearchCity', null);
        this.$store.commit('setCounty', null);
        this.$store.commit('setPropertiesNoPagination', []);

        try {
            this.page = await SiteService.getPropertiesPage();
        } catch (error) {
            this.page = null;
        }

        this.init();
    },
}
</script>
<style>
    .properties-title {
        margin-top: 16px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
    }
    .properties-title h1 {
        font-size: 30px;
        line-height: 45px;
        font-weight: 700;
    }
    .properties-tabs .v-slide-group__wrapper {
        border-bottom: 1px solid #d8d8d8 !important;
    }
    .properties-tabs .v-tab {
        text-transform: unset;
        letter-spacing: 0;
        font-size: 16px;
        font-weight: 400;
        color: #000 !important;
    }
    .properties-tabs .v-tab--active {
        color: #000;
    }
    .properties-tabs .results-found {
        font-size: 14px !important;
    }
    .properties-tabs-fav .v-expansion-panel-header {
        font-size: 20px !important;
        font-weight: 700;
        padding-left: 0;
        padding-right: 0;
    }
    .properties-tabs-fav .v-expansion-panel-content,
    .properties-tabs-fav .v-expansion-panel-content__wrap {
        padding-left: 0;
        padding-right: 0;
    }
    .properties-tabs-fav .roommate-add-text {
        font-size: 16px !important;
    }
    .properties-tabs-fav .v-expansion-panel-header__icon i {
        color: #1976d2 !important;
        font-size: 38px;
    }

    /* Fix for sticky map - override Vuetify's overflow:hidden on tab items */
    .properties-tabs .v-tabs-items,
    .properties-tabs .v-window-item,
    .properties-tabs .v-window-item--active {
        overflow: visible !important;
    }

</style>
